import { render, staticRenderFns } from "./basicSettings.vue?vue&type=template&id=67abfef8"
import script from "./basicSettings.vue?vue&type=script&lang=js"
export * from "./basicSettings.vue?vue&type=script&lang=js"
import style0 from "./basicSettings.vue?vue&type=style&index=0&id=67abfef8&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67abfef8')) {
      api.createRecord('67abfef8', component.options)
    } else {
      api.reload('67abfef8', component.options)
    }
    module.hot.accept("./basicSettings.vue?vue&type=template&id=67abfef8", function () {
      api.rerender('67abfef8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/basicSettings.vue"
export default component.exports